/*
 * Mobile - PDP - Brand Cross Sell Carousel  --  variant: Dynamic Brand Carousel
 * Moonshot experiment id: 35429107   status in Moonshot on 2026-08-27: DEPLOYED   started: 2026-06-25
 * Audience: MOBILE   Target: pdp   (see MGExp.targets in mg-exp-runtime.js)
 * Source: verbatim variant code from cdn.moonshot-ai.com/snippets/36780565.js (prettified);
 *         only change is window.msaiTools._msaiRunVariantBlock -> MGExp.runVariantBlock.
 * Enabled by theme setting: mgexp_pdp_m_brand_xsell
 */
MGExp.run('pdp_m_brand_xsell', { name: "Mobile - PDP - Brand Cross Sell Carousel / Dynamic Brand Carousel", platform: 'mobile', target: 'pdp' }, function () {
  !(function () {
    let e = [],
      t = [];
    const n = {
        Hermès: "hermes",
        "Christian Dior": "dior",
        "Tiffany & Co.": "tiffany-co",
      },
      i =
        "data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22320%22 height=%22320%22%3E%3Crect fill=%22%23f0f0f0%22 width=%22320%22 height=%22320%22/%3E%3Ctext x=%2250%25%22 y=%2250%25%22 dominant-baseline=%22middle%22 text-anchor=%22middle%22 fill=%22%23999%22 font-size=%2214%22 font-family=%22sans-serif%22%3ENo Image%3C/text%3E%3C/svg%3E";
    function l(e) {
      return e
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-|-$/g, "");
    }
    function o(e) {
      const t = (function (e) {
        if (null == e || "" === e) return NaN;
        const t = "string" == typeof e ? parseFloat(e) : e;
        if (isNaN(t)) return NaN;
        let n = !1;
        return (
          (n =
            "string" == typeof e
              ? -1 === e.indexOf(".") && t > 99
              : t === Math.floor(t) && t > 999),
          n ? t / 100 : t
        );
      })(e);
      return isNaN(t)
        ? ""
        : "$" +
            t.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
    }
    function a(e, t) {
      if ("undefined" != typeof AbortController) {
        const n = new AbortController(),
          i = setTimeout(function () {
            n.abort();
          }, t);
        return fetch(e, { signal: n.signal }).finally(function () {
          clearTimeout(i);
        });
      }
      return fetch(e);
    }
    function s(e) {
      if (!e) return "";
      const t = "string" == typeof e ? e : e.src || e.url || "";
      return t ? t.split("?")[0] + "?width=520" : "";
    }
    function r(e) {
      if (!e) return Promise.resolve(null);
      const t = (function (e) {
          return n[e] ? n[e] : l(e.replace(/&/g, ""));
        })(e),
        i = l(e),
        o = [t];
      i !== t && o.push(i);
      const s = e.split(/\s+/);
      if (s.length > 1) {
        const e = s[s.length - 1].toLowerCase().replace(/[^a-z0-9]/g, "");
        -1 === o.indexOf(e) && o.push(e);
      }
      return (function t(n) {
        return n >= o.length
          ? Promise.resolve(null)
          : ((i = o[n]),
            a("/collections/" + i + "/products.json?limit=24", 6e3)
              .then(function (e) {
                return e.ok
                  ? e.json().catch(function () {
                      return null;
                    })
                  : null;
              })
              .catch(function () {
                return null;
              })).then(function (i) {
              return i && i.products && i.products.length > 0
                ? { products: i.products, vendor: e }
                : t(n + 1);
            });
        var i;
      })(0);
    }
    function c(e, t) {
      const n = document.createElement("div");
      n.className = "msai-multi-xsell-card";
      const l = e.variants && e.variants[0];
      if (
        l &&
        null != l.compare_at_price &&
        "" !== l.compare_at_price &&
        "0.00" !== l.compare_at_price &&
        0 !== l.compare_at_price
      ) {
        const e = o(l.compare_at_price);
        if (e) {
          const t = document.createElement("span");
          ((t.className = "msai-multi-xsell-retail"),
            (t.textContent = "Est. Retail " + e),
            n.appendChild(t));
        }
      }
      const a = document.createElement("img");
      var r;
      ((a.className = "msai-multi-xsell-img"),
        (a.src =
          s((r = e).images && r.images[0]) ||
          s(r.featured_image) ||
          s(r.image) ||
          i),
        (a.alt = e.title || ""),
        (a.loading = "lazy"),
        (a.onerror = function () {
          ((this.src = i), (this.onerror = null));
        }),
        n.appendChild(a));
      const c = document.createElement("h3");
      ((c.className = "msai-multi-xsell-vendor"),
        (c.textContent = e.vendor || t || ""),
        n.appendChild(c));
      const d = document.createElement("p");
      d.className = "msai-multi-xsell-name";
      let m = e.title || "";
      const u = e.vendor || t || "";
      (u && 0 === m.indexOf(u + " ") && (m = m.substring(u.length + 1)),
        (d.textContent = m),
        n.appendChild(d));
      const p = document.createElement("a");
      ((p.className = "msai-multi-xsell-link"),
        (p.href = "/products/" + (e.handle || "")),
        p.setAttribute("aria-label", e.title || ""),
        n.appendChild(p));
      const f = document.createElement("div");
      f.className = "msai-multi-xsell-bottom";
      const h = document.createElement("span");
      if (
        ((h.className = "msai-multi-xsell-price"),
        l && null != l.price && "" !== l.price)
      ) {
        const e = o(l.price);
        e && (h.textContent = e);
      }
      if ((f.appendChild(h), l && l.id)) {
        const e = document.createElement("button");
        ((e.className = "msai-multi-xsell-quick-add"),
          (e.innerHTML =
            '<svg width="14" height="14" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M19.9805 18.668L18.3398 8.82422C18.2747 8.1862 17.9883 7.63932 17.4805 7.18359C16.9727 6.72786 16.3997 6.5 15.7617 6.5H14.375V4.83984C14.375 4.20182 14.2643 3.60286 14.043 3.04297C13.8346 2.48307 13.5352 1.99479 13.1445 1.57812C12.7669 1.16146 12.3112 0.835938 11.7773 0.601562C11.2435 0.354167 10.6576 0.230469 10.0195 0.230469C9.38151 0.230469 8.79557 0.354167 8.26172 0.601562C7.72786 0.835938 7.26562 1.16146 6.875 1.57812C6.48438 1.99479 6.17839 2.48307 5.95703 3.04297C5.73568 3.60286 5.625 4.20182 5.625 4.83984V6.5H4.12109C3.48307 6.5 2.91016 6.72786 2.40234 7.18359C1.89453 7.63932 1.60807 8.17318 1.54297 8.78516L0.0390625 18.6484C0 18.9089 0.00651042 19.1367 0.0585938 19.332C0.110677 19.5404 0.201823 19.7161 0.332031 19.8594C0.449219 19.9896 0.592448 20.0872 0.761719 20.1523C0.94401 20.2305 1.15234 20.2695 1.38672 20.2695H18.4375C18.763 20.2695 19.0234 20.2174 19.2188 20.1133C19.4141 20.0091 19.5573 19.9049 19.6484 19.8008C19.7396 19.6966 19.8242 19.5534 19.9023 19.3711C19.9805 19.1888 20.0065 18.9544 19.9805 18.668ZM6.875 4.83984C6.875 3.91536 7.16797 3.1276 7.75391 2.47656C8.33984 1.8125 9.09505 1.48047 10.0195 1.48047C10.944 1.48047 11.6927 1.8125 12.2656 2.47656C12.8385 3.1276 13.125 3.91536 13.125 4.83984V6.5H6.875V4.83984ZM18.4961 19L1.46484 19.0195C1.41276 19.0195 1.36068 19.0065 1.30859 18.9805C1.26953 18.9414 1.25651 18.8828 1.26953 18.8047L2.77344 8.96094C2.8125 8.63542 2.96224 8.35547 3.22266 8.12109C3.49609 7.8737 3.79557 7.75 4.12109 7.75H5.625V9.17578C5.44271 9.29297 5.29297 9.44922 5.17578 9.64453C5.05859 9.82682 5 10.0286 5 10.25C5 10.6016 5.11719 10.901 5.35156 11.1484C5.59896 11.3828 5.89844 11.5 6.25 11.5C6.60156 11.5 6.89453 11.3828 7.12891 11.1484C7.3763 10.901 7.5 10.6016 7.5 10.25C7.5 10.0286 7.44141 9.82682 7.32422 9.64453C7.20703 9.44922 7.05729 9.29297 6.875 9.17578V7.75H13.125V9.17578C12.9427 9.29297 12.793 9.44922 12.6758 9.64453C12.5586 9.82682 12.5 10.0286 12.5 10.25C12.5 10.6016 12.6172 10.901 12.8516 11.1484C13.099 11.3828 13.3984 11.5 13.75 11.5C14.1016 11.5 14.3945 11.3828 14.6289 11.1484C14.8763 10.901 15 10.6016 15 10.25C15 10.0286 14.9414 9.82682 14.8242 9.64453C14.707 9.44922 14.5573 9.29297 14.375 9.17578V7.75H15.7617C16.0872 7.75 16.3802 7.8737 16.6406 8.12109C16.9141 8.35547 17.0703 8.64844 17.1094 9L18.7305 18.8242C18.7435 18.8633 18.7305 18.9023 18.6914 18.9414C18.6523 18.9805 18.5872 19 18.4961 19Z" fill="#333333"></path>\n</svg><span>Quick Add</span>'),
          e.addEventListener("click", function (t) {
            (t.preventDefault(), t.stopPropagation());
            const n = l.id;
            fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ items: [{ id: n, quantity: 1 }] }),
            }).then(function () {
              ((e.querySelector("span").textContent = "Added!"),
                setTimeout(function () {
                  e.querySelector("span").textContent = "Quick Add";
                }, 1500));
            });
          }),
          f.appendChild(e));
      }
      return (n.appendChild(f), n);
    }
    !(async function (n, i, l, o, a) {
      let s = {
        multi_target_selectors: e,
        page_identifier_selector: "section.prod-page",
        exclude_from_timeout: t,
        selector_timeout: 8e3,
      };
      await MGExp.runVariantBlock(n, i, l, o, a, s);
    })(
      ["section.prod-page", '[id*="dc_product_recommendations"]'],
      ".msai-xsell-applied",
      function (e, t) {
        const [n, i] = t,
          l = document.createElement("div");
        l.className = "msai-xsell msai-xsell-hidden";
        const o = document.createElement("h2");
        ((o.className = "msai-xsell-title"), l.appendChild(o));
        const s = document.createElement("div");
        ((s.className = "msai-xsell-track"),
          l.appendChild(s),
          i.insertAdjacentElement("beforebegin", l),
          l.classList.add("msai-xsell-applied"),
          a(window.location.pathname.replace(/\/+$/, "") + ".js", 6e3)
            .then(function (e) {
              return e.ok
                ? e.json().catch(function () {
                    return null;
                  })
                : null;
            })
            .then(function (e) {
              if (!e || "object" != typeof e) return null;
              const t = e.vendor || "",
                n = e.handle || "",
                i = e.id,
                l = (e.type || e.product_type || "").toLowerCase();
              return r(t).then(function (e) {
                if (!e || !e.products || e.products.length < 1) return null;
                const o = [],
                  a = [],
                  s = {};
                e.products.forEach(function (e) {
                  if (n && e.handle === n) return;
                  if (i && e.id && e.id === i) return;
                  if (
                    !(function (e) {
                      return (
                        e.variants &&
                        e.variants.some(function (e) {
                          return !1 !== e.available;
                        })
                      );
                    })(e)
                  )
                    return;
                  if (/bold/i.test(e.title || "") || /bold/i.test(e.vendor || ""))
                    return;
                  const t = e.handle || String(e.id || "");
                  if (!t || s[t]) return;
                  s[t] = !0;
                  const r = (e.product_type || "").toLowerCase();
                  l && r === l ? o.push(e) : a.push(e);
                });
                const r = o.concat(a).slice(0, 8);
                return r.length < 5 ? null : { items: r, vendor: e.vendor || t };
              });
            })
            .then(function (e) {
              e &&
                ((o.textContent = "More from " + e.vendor),
                e.items.forEach(function (t) {
                  s.appendChild(c(t, e.vendor));
                }),
                l.classList.remove("msai-xsell-hidden"));
            })
            .catch(function () {}));
      },
      '\n  .msai-xsell { padding: 24px 0; background: #fafafa; position: relative; }\n  .msai-xsell-hidden { display: none !important; }\n  .msai-xsell-title { font-family: "Playfair Display", serif; font-size: 32px; font-weight: 400; text-align: center; margin: 0 0 8px; color: #2f2a29; text-transform: capitalize; }\n  /* stylelint-disable-next-line plugin/no-unsupported-browser-features */\n  .msai-xsell-track { display: flex; gap: 8px; overflow-x: scroll; -webkit-overflow-scrolling: touch; scrollbar-width: none; padding: 0 16px 4px; }\n  .msai-xsell-track::-webkit-scrollbar { display: none; }\n  .msai-multi-xsell-card { flex: 0 0 310px; text-decoration: none; color: inherit; display: flex; flex-direction: column; justify-content: space-between; padding: 8px; background: #fff; position: relative; }\n  .msai-multi-xsell-retail { font-family: Raleway, sans-serif; font-size: 9px; font-weight: 400; color: #4a4a4a; line-height: 1; margin: 0; }\n  .msai-multi-xsell-img { display: block; max-width: 214px; width: 100%; margin: 4px auto 16px; }\n  .msai-multi-xsell-vendor { font-family: Raleway, sans-serif; font-size: 12px; font-weight: 500; color: #333; line-height: 1.75; margin: 0; }\n  .msai-multi-xsell-name { font-family: Raleway, sans-serif; font-size: 12px; font-weight: 400; color: #333; line-height: 1.6; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; margin: 0; }\n  .msai-multi-xsell-bottom { display: flex; align-items: center; margin-top: 4px; }\n  .msai-multi-xsell-price { font-family: Raleway, sans-serif; font-size: 12px; font-weight: 500; color: #333; line-height: 1; }\n  .msai-multi-xsell-compare { font-size: 11px; color: #666; text-decoration: line-through; margin-left: 6px; font-weight: 400; }\n  .msai-multi-xsell-quick-add { display: inline-flex; align-items: center; gap: 4px; margin-left: 8px; font-family: Raleway, sans-serif; font-size: 12px; font-weight: 400; color: #333; background: none; border: none; padding: 0; cursor: pointer; position: relative; z-index: 1; border-bottom: 1px solid rgba(197, 197, 196, var(--tw-border-opacity)); }\n  .msai-multi-xsell-quick-add svg { width: 14px; height: 14px; }\n  .msai-multi-xsell-link { position: absolute; inset: 0; }\n',
    );
  })();
});
